
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function isWX () {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export function getSearchValue (key) {
  let q = location.search
  const keyValuePairs = []
  if (q.length > 1) {
    const idx = q.indexOf('?')
    q = q.substring(idx + 1, q.length)
  } else {
    q = null
  }
  if (q) {
    for (let i = 0; i < q.split('&').length; i++) {
      keyValuePairs[i] = q.split('&')[i]
    }
  }
  for (let j = 0; j < keyValuePairs.length; j++) {
    if (keyValuePairs[j].split('=')[0] === key) {
      // 这里需要解码，url传递中文时location.href获取的是编码后的值
      // 但FireFox下的url编码有问题
      return decodeURI(keyValuePairs[j].split('=')[1])
    }
  }
  return ''
}

export function formatPrice (val) {
  if (val) {
    return (val / 100).toFixed(2)
  } else {
    return 0
  }
}

export function checkMobile (val) {
  return (/^1(3|4|5|6|7|8|9)\d{9}$/.test(val))
}



// WEBPACK FOOTER //
// ./src/utils/helper.js